import React from 'react'
import { useNavigate } from "react-router-dom";
import { cdnImage } from '../../helper/constants';

const ListItem = ({ node, onMenuClick }) => {
  const navigate = useNavigate();
  const handalLinkToggle = (item) => {
    let pdfs = 'assets/pdf';
    if (item.link?.includes(pdfs)){
      window.open(`${cdnImage}${item.link}`);
    }else{
      if(item?.target){
        window.open(item.link, "_blank");
      }else{
        navigate(item.link)
      }
    }
  }
  return <li> <a onMouseOver={onMenuClick} onClick={() => handalLinkToggle(node)} className='submenu_arrow_link mega-menu-link'>{node?.name}</a></li>;
};

export default ListItem